import { Fragment } from "react";
import { usd } from "@/lib/format";
import { Card } from "@/components/common/Ornament";

export function groupCost(items = []) {
  const sections = [];
  items.forEach((it) => {
    let s = sections.find((x) => x.name === it.section);
    if (!s) { s = { name: it.section, items: [], total: 0 }; sections.push(s); }
    s.items.push(it);
    s.total += Number(it.amount) || 0;
  });
  return { sections, total: sections.reduce((a, s) => a + s.total, 0) };
}

export default function CostDetail({ items, inputs }) {
  const { sections, total } = groupCost(items);
  if (!sections.length) return null;
  return (
    <Card eyebrow="Architect's Preliminary Estimate · 08/28/2026" title="Construction Cost Detail" testId="cost-detail-table">
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[520px]">
          <thead>
            <tr className="border-b border-[#0F2E23] text-xs uppercase tracking-wider text-[#3E5C4E]">
              <th className="text-left py-2">Line item</th><th className="text-right py-2">Amount</th><th className="text-right py-2 w-24">% of total</th>
            </tr>
          </thead>
          <tbody>
            {sections.map((s, si) => (
              <Fragment key={s.name}>
                <tr><td colSpan={3} className="pt-4 pb-1 eyebrow">{s.name}</td></tr>
                {s.items.map((it, i) => (
                  <tr key={i} className="border-b border-[#E2DCD2] text-slate-700" data-testid={`cost-detail-row-${si}-${i}`}>
                    <td className="py-1.5 pr-2">{it.item}</td>
                    <td className="py-1.5 text-right font-mono-num">{Number(it.amount) ? usd(it.amount) : "Included"}</td>
                    <td className="py-1.5 text-right font-mono-num text-xs text-slate-500">{total ? ((Number(it.amount) / total) * 100).toFixed(1) : "0.0"}%</td>
                  </tr>
                ))}
                <tr className="bg-[#F9F6F0] font-semibold text-[#0F2E23]">
                  <td className="py-2 pl-2">Subtotal {s.name}</td>
                  <td className="py-2 text-right font-mono-num" data-testid={`cost-detail-subtotal-${si}`}>{usd(s.total)}</td>
                  <td className="py-2 text-right font-mono-num text-xs">{total ? ((s.total / total) * 100).toFixed(1) : "0.0"}%</td>
                </tr>
              </Fragment>
            ))}
            <tr className="bg-[#0F2E23] text-[#F9F6F0] font-semibold">
              <td className="py-2.5 pl-2">Total Cost of the Work</td>
              <td className="py-2.5 text-right font-mono-num" data-testid="cost-detail-total">{usd(total)}</td>
              <td className="py-2.5 text-right font-mono-num text-xs pr-1">100.0%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500 mt-4 leading-relaxed">
        * Development fee line item added for verification by the lender. How the estimate maps to the model at current inputs: hard costs {usd(inputs.hard)} (general conditions + direct cost, less FF&amp;E) · FF&amp;E {usd(inputs.ffe)} · soft costs {usd(inputs.soft)} (add-ons plus franchise fee and third-party reports) · land {usd(inputs.land)}.
      </p>
    </Card>
  );
}
